import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const RES_EXCLUSION = ['/clinicalSimulation'];

const useExcludeResourceApi = () => {
    const location = useLocation();
    const { pathname } = location;

    const isExcludeResouceApi = useMemo(() => {
        if (pathname && pathname?.length > 0) {
            return RES_EXCLUSION.some((ex) => pathname.startsWith(ex));
        }
        return false;
    }, [pathname]);

    return {
        isExcludeResouceApi,
    };
};

export default useExcludeResourceApi;
